import React, { FC } from 'react';
import { RequiredFormProps } from './RequiredFormProps';
import ProjectNameInput from '../../ProjectTab/ProjectNameInput';
import ProjectDatesFields from '../../ProjectTab/ProjectDatesFields';
import SiteInfoSelects from '../../SiteTab/SiteInfoFields/SiteInfoSelects';
import LocationInfoCountrySelect from '../../SiteTab/LocationInfoCountrySelect';
import ProjectConfidentialButton from '../../ProjectTab/ProjectConfidentialButton';
import useTranslation from '../../../hooks/useTranslation';
import Text from '@ingka/text';
import ProjectCountryResponsible from '../../ProjectCountryResponsible';
import BUInput from '../../SiteTab/BUInputs';

const RequiredForm: FC<RequiredFormProps> = ({
  countries,
  isConfidentialAllowed,
  onCountryChange,
  userList,
  BUList,
  onBUChange,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectInformation')}
      </Text>
      <ProjectNameInput />
      <ProjectDatesFields openingDate />
      <LocationInfoCountrySelect
        countries={countries}
        onCountryChange={onCountryChange}
      />
      <BUInput BuList={BUList} onBUChange={onBUChange} required />
      <SiteInfoSelects unitType transactionType />
      <ProjectCountryResponsible usersList={userList} required={true} />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
    </>
  );
};

export default RequiredForm;
